import React from "react";

function LetHelpYou() {
  return (
    <>
      <div className="container mt-50 mb-50 ">
        <div
          className="testimonial-style-three-items bg-gray blurry-shape-right-bottom"
          // style={{ backgroundImage: "url(assets/img/shape/3.jpg)" }}
        >
          <div className="testimonial-style-three-carousel swiper">
            <div className="swiper-wrapper">
              <div className="testimonial-style-three">
                <div className="left">
                  <img
                    src="https://validthemes.net/site-template/robok/assets/img/shape/12.png"
                    alt="Image Not Found"
                  />
                  <img
                    src="https://validthemes.net/site-template/robok/assets/img/icon/quote-two.png"
                    alt="Image Not Found"
                  />
                </div>
                <div className="right">
                  <p>
                    Let us help you empower your users with a seamless mobile
                    wallet that meets the evolving demands of the cryptocurrency
                    landscape.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default LetHelpYou;
